var degreeList = [{
  value: 3,
  label: '高中'
}, {
  value: 4,
  label: '专科'
}, {
  value: 5,
  label: '本科'
}, {
  value: 6,
  label: '硕士'
}, {
  value: 7,
  label: '博士'
}, {
  value: 124,
  label: '其他'
}];

var eduModeList = [{
  value: 17,
  label: '统招'
}, {
  value: 4,
  label: '非统招'
}];

var coSizeList = [{
  value: 21,
  label: '50人以下'
}, {
  value: 22,
  label: '50-100人'
}, {
  value: 23,
  label: '50-100人'
}, {
  value: 24,
  label: '200-500人'
}, {
  value: 25,
  label: '500-1000人'
}, {
  value: 26,
  label: '1000人以上'
}];

var jobNatureList = [{
  value: 11,
  label: '全职'
}, {
  value: 12,
  label: '灵活雇用'
}, {
  value: 13,
  label: '实习'
}];

var postExperienceList = [{
  value: 47,
  label: '应届'
}, {
  value: 48,
  label: '1年经验'
}, {
  value: 49,
  label: '2年经验'
}, {
  value: 60,
  label: '3年经验'
}, {
  value: 61,
  label: '4年经验'
}, {
  value: 62,
  label: '5年经验'
}, {
  value: 63,
  label: '6年及以上经验'
}];

let postionFlexColumnsList = [
  {value:129,label:'账务'},
  {value:130,label:'人事'},
  {value:131,label:'行政'},
  {value:132,label:'设计师'},
  {value:133,label:'产品'},
  {value:134,label:'开发人员'},
  {value:135,label:'前端'},
  {value:136,label:'新媒体'}
];

export {
  degreeList,
  eduModeList,
  coSizeList,
  jobNatureList,
  postExperienceList,
  postionFlexColumnsList
};